/**
 * @file geneDiseaseNew.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jan 08, 2022 13:04
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    GENE_DISEASE_NEW_REQUEST,
    geneDiseaseNewSuccess,
    geneDiseaseNewFailure,
} from 'src/store/actions/geneModel/geneModelDb.actions';

import {
    geneDiseaseNewDialogSet,
} from 'src/store/actions/geneModel/geneModelPages.actions';

import {
    geneDiseaseReset,
    geneDiseaseFindRequest,
} from 'src/store/actions/geneModel/geneModelDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/geneModel/geneDiseaseNew';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            geneModelId: payload.geneModelId,
            disease: payload.disease,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(geneDiseaseNewSuccess(resp.payload));

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        // close the dialog and route to the edit page
        yield put(geneDiseaseNewDialogSet(false));

        const geneDiseaseId = resp.payload.geneDiseaseId;

        yield put(geneDiseaseReset());
        yield put(geneDiseaseFindRequest(geneDiseaseId));

        const targetPath = `geneDisease/${geneDiseaseId}`;
        return action.payload.navigate(targetPath);

    } catch (error) {
        yield put(geneDiseaseNewFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(GENE_DISEASE_NEW_REQUEST, createRequestSaga);
}
